import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Service } from './refresh-restore.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
import { DataProtectionVariables } from '../../../dataprotection-common/dataprotection-variables';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'refresh-restore',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./refresh-restore.scss')],
  template: require('./refresh-restore.html')
})

export class RefreshRestore {
  @Input('isVisible') isVisible: boolean;
  @Input('mode') mode: string;
  @Input('selectedEntity') selectedEntity;
  @Output('onRequestStatusChange') emitter = new EventEmitter();

  private subscribeHandler;
  private submitted: boolean = false;
  private active: boolean = true;
  private vmName = '';
  private vcHost = '';

  private isRequestPending: boolean = false;
  private emitData = {
    'status': '',
  };

  constructor(public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  onSubmit() {
    this.isRequestPending = true;
    this.emitData.status = 'pending';
    this.emitter.emit(this.emitData);
    switch(this.mode){
      case DataProtectionVariables.RESTORE_MODES['VM']:
        this.refreshRestorePointsVm();
        break;
      case DataProtectionVariables.RESTORE_MODES['DELETED_VM']:
        this.refreshRestorePointsDeletedVm();
        break;
      default :
        this.refreshRestorePointsVm();
    }
  }

  onCancelButtonClicked() {
    this.emitter.emit();
  }

  //Life Cycle Hooks
  ngOnInit() {
  }

  ngOnChanges(changes) {
    if ( changes && changes.selectedEntity ) {
        this.vmName = (this.selectedEntity.name) ? this.selectedEntity.name : '';
        this.vcHost = (this.selectedEntity.vcHost) ? this.selectedEntity.vcHost : '';
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if(this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  refreshRestorePointsVm() {
    if(this.selectedEntity && this.selectedEntity.entity_id && this.selectedEntity.entity_id !== '' &&
      this.selectedEntity.vcenter_instanceId && this.selectedEntity.vcenter_instanceId !== '') {
      this.subscribeHandler = this.service.refreshRestorePointsVm(this.selectedEntity.entity_id, this.selectedEntity.vcenter_instanceId)
        .subscribe(
          res => {
            this.handleSuccess();
          },
          error => this.handleError(error),
          () => {}
        );
    }
    else {}
  }

  refreshRestorePointsDeletedVm() {
    if(this.selectedEntity && this.selectedEntity.entity_id && this.selectedEntity.entity_id !== '' &&
      this.selectedEntity.vcenter_instanceId && this.selectedEntity.vcenter_instanceId !== '') {
      this.subscribeHandler = this.service.refreshRestorePointsDeletedVm(this.selectedEntity.entity_id, this.selectedEntity.vcenter_instanceId)
        .subscribe(
          res => {
            this.handleSuccess();
          },
          error => this.handleError(error),
          () => {}
        );
    }
    else {}
  }

  handleSuccess() {
    this.isRequestPending = false;
    this.emitData.status = 'success';
    this.emitter.emit(this.emitData);
  }

  handleError(error) {
    this.isRequestPending = false;
    this.emitData.status = 'error';
    this.emitter.emit(this.emitData);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/common-ops/refresh-restore/refresh-restore.component.ts